export enum B2bFilterType {
    all = 0,
    unprocessed = 1,
}